<template>
  <div>
        <keep-alive>
              <router-view v-if='$route.meta.keepAlive'></router-view>
        </keep-alive>
        <router-view v-if='!$route.meta.keepAlive'></router-view>
  </div>
</template>

<script>
export default {
  name: "DoctorStatistics",
  data() {
    return {
      msg: ""
    }
  },
  component: {
    //someComponent
  },
  methods: {
    //
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>